import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-c002e3ca.esm.js';
import { create } from 'apisauce';
import AsyncStorage from '@react-native-async-storage/async-storage';
import dayjs from 'dayjs';

var prefix = "cache";
var expiryInMinutes = 5;
var store = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key, value) {
    var item;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          item = {
            value: value,
            timestamp: Date.now()
          };
          _context.next = 4;
          return AsyncStorage.setItem(prefix + key, JSON.stringify(item));
        case 4:
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          console.error("error while caching", _context.t0);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function store(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var inExpired = function inExpired(item) {
  var now = dayjs();
  var storedTime = dayjs.unix(item.timestamp);
  return now.diff(storedTime, "minutes") > expiryInMinutes;
};
var get$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
    var value, item;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return AsyncStorage.getItem(prefix + key);
        case 3:
          value = _context2.sent;
          item = JSON.parse(value);
          if (item) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", null);
        case 7:
          if (!inExpired(item)) {
            _context2.next = 11;
            break;
          }
          _context2.next = 10;
          return AsyncStorage.removeItem(prefix + key);
        case 10:
          return _context2.abrupt("return", null);
        case 11:
          return _context2.abrupt("return", item.value);
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](0);
          console.error("error while getting cached value", _context2.t0);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 14]]);
  }));
  return function get(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var cache = {
  store: store,
  get: get$1
};

var apiClient = create({
  baseURL: "http://192.168.1.104:9000/api"
});
var get = apiClient.get;
apiClient.secureGet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, params, axiosConfig) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return get(url, params, axiosConfig);
        case 2:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 6;
            break;
          }
          cache.store(url, response.data);
          return _context.abrupt("return", response);
        case 6:
          console.error("Error while fetching from network", response.problem);
          _context.next = 9;
          return cache.get(url);
        case 9:
          data = _context.sent;
          return _context.abrupt("return", data ? {
            ok: true,
            data: data
          } : response);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// apiClient.get('/listings').then(response => {
//     if(!response.ok)

// });

export { apiClient as a };
